// src/components/clienti/ClienteTable.jsx
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Edit, Mail, Phone, Trash2, Users } from "lucide-react";

export default function ClienteTable({ clienti, onEdit, onDelete, isLoading, deleteLoading = false }) {
  if (isLoading) {
    return (
      <Card className="glass-effect border-0 shadow-xl">
        <CardHeader className="p-6 border-b border-slate-100">
          <CardTitle className="text-xl font-bold text-slate-800">
            Lista Clienti
          </CardTitle>
        </CardHeader>
        <CardContent className="p-6">
          <div className="space-y-4">
            {Array(5).fill(0).map((_, i) => (
              <div key={i} className="flex items-center justify-between p-4 rounded-lg border">
                <div className="flex items-center gap-4">
                  <Skeleton className="w-10 h-10 rounded-full" />
                  <div className="space-y-2">
                    <Skeleton className="h-4 w-32" />
                    <Skeleton className="h-3 w-24" />
                  </div>
                </div>
                <div className="flex gap-2">
                  <Skeleton className="h-8 w-8 rounded" />
                  <Skeleton className="h-8 w-8 rounded" />
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="glass-effect border-0 shadow-xl">
      <CardHeader className="p-6 border-b border-slate-100">
        <CardTitle className="text-xl font-bold text-slate-800 flex items-center gap-2">
          <Users className="w-5 h-5" />
          Lista Clienti ({clienti.length})
        </CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        {clienti.length > 0 ? (
          <div className="overflow-x-auto">
            <Table>
              <TableHeader>
                <TableRow className="border-b border-slate-100">
                  <TableHead className="font-semibold text-slate-700">Nome</TableHead>
                  <TableHead className="font-semibold text-slate-700">Cognome</TableHead>
                  <TableHead className="font-semibold text-slate-700">Telefono</TableHead>
                  <TableHead className="font-semibold text-slate-700">Email</TableHead>
                  <TableHead className="font-semibold text-slate-700">Azioni</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {clienti.map((cliente) => (
                  <TableRow key={cliente.id} className="border-b border-slate-50 hover:bg-slate-50 transition-colors">
                    <TableCell className="font-medium text-slate-800">
                      {cliente.nome}
                    </TableCell>
                    <TableCell className="font-medium text-slate-800">
                      {cliente.cognome}
                    </TableCell>
                    <TableCell>
                      <div className="flex items-center gap-2 text-slate-600">
                        <Phone className="w-4 h-4" />
                        {cliente.telefono || "-"}
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className="flex items-center gap-2 text-slate-600">
                        <Mail className="w-4 h-4" />
                        {cliente.email || "-"}
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className="flex gap-2">
                        <Button
                          variant="ghost"
                          size="icon"
                          onClick={() => onEdit(cliente)}
                          disabled={deleteLoading}
                          className="hover:bg-blue-50 hover:text-blue-600"
                        >
                          <Edit className="w-4 h-4" />
                        </Button>
                        <Button
                          variant="ghost"
                          size="icon"
                          onClick={() => onDelete(cliente)}
                          disabled={deleteLoading}
                          className="hover:bg-red-50 hover:text-red-600"
                        >
                          <Trash2 className="w-4 h-4" />
                        </Button>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        ) : (
          <div className="text-center py-12">
            <Users className="w-16 h-16 text-slate-300 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-slate-600 mb-2">
              Nessun cliente registrato
            </h3>
            <p className="text-slate-500">
              Inizia aggiungendo il primo cliente
            </p>
          </div>
        )}
      </CardContent>
    </Card>
  );
}